// Custom Product Grid JavaScript
document.addEventListener('DOMContentLoaded', function() {
  
  // Share Button Functionality - Native Dawn Share System
  document.addEventListener('click', function(e) {
    // Support both old and new share button classes
    const shareButton = e.target.closest('.product-share-button') || e.target.closest('.share-button');
    
    if (shareButton) {
      e.preventDefault();
      e.stopPropagation();
      
      const shareUrl = shareButton.dataset.shareUrl;
      const shareTitle = shareButton.dataset.shareTitle || 'Check out this product';
      
      if (navigator.share) {
        // Use Web Share API if available (Native Shopify Dawn approach)
        navigator.share({
          title: shareTitle,
          url: shareUrl
        }).catch(function(error) {
          // Only log if it's not a user cancellation
          if (error.name !== 'AbortError') {
            console.error('Error sharing:', error);
          }
        });
      } else {
        // Fallback to copying URL to clipboard
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl).then(function() {
            showTooltip(shareButton, 'Link copied!');
          }).catch(function() {
            fallbackCopyToClipboard(shareUrl, shareButton);
          });
        } else {
          fallbackCopyToClipboard(shareUrl, shareButton);
        }
      }
    }
  });
  
  // Fallback copy to clipboard function
  function fallbackCopyToClipboard(text, button) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.opacity = '0';
    textArea.style.pointerEvents = 'none';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showTooltip(button, 'Link copied!');
      } else {
        showTooltip(button, 'Failed to copy');
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      showTooltip(button, 'Failed to copy');
    }
    
    document.body.removeChild(textArea);
  }
  
  // Wishlist Button Functionality - Removed as per user request
  /*
  document.addEventListener('click', function(e) {
    const wishlistButton = e.target.closest('.swym-add-to-wishlist-view-product');
    if (wishlistButton) {
      e.preventDefault();
      wishlistButton.classList.toggle('active');
      
      // If Swym is loaded, use their API
      if (window._swat) {
        const productId = wishlistButton.dataset.productId;
        // Trigger Swym wishlist functionality
        window._swat.addToWishList({
          product: { id: productId }
        });
      } else {
        // Fallback animation
        showTooltip(wishlistButton, 'Added to wishlist!');
      }
    }
  });
  */
  
  // Swatch Click Functionality - Support both old and new classes
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.product-swatch') || e.target.closest('.product-item');
    
    if (swatch && !swatch.classList.contains('product-item--more') && !swatch.classList.contains('product-swatch--more')) {
      e.preventDefault();
      e.stopPropagation();
      
      const optionValue = swatch.dataset.optionValue;
      
      // Remove active from siblings (support both container types)
      const swatchContainer = swatch.closest('.product-swatches') || swatch.closest('.swatchContainer');
      if (swatchContainer) {
        swatchContainer.querySelectorAll('.product-swatch, .product-item').forEach(s => {
          s.classList.remove('active');
        });
      }
      
      // Add active to clicked swatch
      swatch.classList.add('active');
      
      // You can add logic here to change the product image based on the selected variant
      console.log('Selected variant:', optionValue);
    }
  });
  
  // Helper function to show tooltip
  function showTooltip(element, message) {
    // Remove any existing tooltips
    const existingTooltip = document.querySelector('.custom-tooltip');
    if (existingTooltip) {
      existingTooltip.remove();
    }
    
    // Create tooltip
    const tooltip = document.createElement('div');
    tooltip.className = 'custom-tooltip';
    tooltip.textContent = message;
    document.body.appendChild(tooltip);
    
    // Position tooltip
    const rect = element.getBoundingClientRect();
    tooltip.style.position = 'fixed';
    tooltip.style.left = rect.left + rect.width / 2 + 'px';
    tooltip.style.top = rect.top - 10 + 'px';
    tooltip.style.transform = 'translate(-50%, -100%)';
    
    // Remove after delay
    setTimeout(() => {
      tooltip.classList.add('fade-out');
      setTimeout(() => tooltip.remove(), 300);
    }, 2000);
  }
  
  // Lazy load product images
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0.01
    });
    
    // Observe all product images
    document.querySelectorAll('.custom-product-card img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }
  
});

// Add tooltip styles
const style = document.createElement('style');
style.textContent = `
  .custom-tooltip {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    z-index: 9999;
    pointer-events: none;
    opacity: 1;
    transition: opacity 0.3s ease;
  }
  
  .custom-tooltip.fade-out {
    opacity: 0;
  }
  
  .product-swatch.active {
    box-shadow: 0 0 0 2px #333;
    transform: scale(1.2);
  }
`;
document.head.appendChild(style);
